import * as classNames from 'classnames'
import * as React from 'react'
import { ILegalEntityObj, IOrgObj } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import LegalEntityForm from './LegalEntityForm'

interface ILegalEntityPaneProps {
  currentStep: number
  isSaved: boolean
  isSaving: boolean
  organization: IOrgObj
  isEdit?: boolean
  legalEntity: ILegalEntityObj
  isCompleted: boolean
  orgId: string
  isLegalEntityCompleted?: boolean
  onCompleteStep: (step: number) => void
  onSaveLegalEntity: (legalEntity: ILegalEntityObj) => Promise<any>
  showMessage: (message: string, isError: boolean) => void
}

class LegalEntityPane extends React.Component<ILegalEntityPaneProps> {
  public render() {
    const {
      currentStep,
      legalEntity,
      isSaved,
      isSaving,
      isLegalEntityCompleted,
      onCompleteStep,
      onSaveLegalEntity,
      showMessage
    } = this.props

    const bodyStyle = classNames(
      { 'pointer-events-auto opacity1': !isSaving },
      { 'pointer-events-none opacity04': isSaving }
    )

    return (
      <section>
        <div className={bodyStyle}>
          <LegalEntityForm
            currentStep={currentStep}
            isSaved={isSaved}
            organization={this.props.organization}
            isCompleted={this.props.isCompleted}
            legalEntity={legalEntity}
            orgId={this.props.orgId}
            isEdit={this.props.isEdit}
            isLegalEntityCompleted={isLegalEntityCompleted}
            onCompleteStep={onCompleteStep}
            onSaveLegalEntity={onSaveLegalEntity}
            showMessage={showMessage}
          />
        </div>
      </section>
    )
  }
}

export default LegalEntityPane



// WEBPACK FOOTER //
// ./src/components/organizations/create/legalentity/LegalEntity.tsx